/* istanbul ignore file */

import { EffectType } from './animation-effects';

const shrinkElement = (el: HTMLElement, progress: number, { to = 100 }: EffectType): void => {
  el.style.width = `${(1 - progress) * to}%`;
};

const growElement = (el: HTMLElement, progress: number, { to = 100 }: EffectType): void => {
  el.style.width = `${progress * to}%`;
};

const slideOutToRightRelative = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.right = `calc(${progress * to + from}%)`;
  el.style.position = 'relative';
};

const slideOutToLeftRelative = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.left = `calc(${progress * to + from}%)`;
  el.style.position = 'relative';
};

const slideInFromLeftRelative = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType): void => {
  el.style.left = `calc(${(1 - progress) * from + to}%)`;
  el.style.position = 'relative';
};

const slideInFromRightRelative = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType): void => {
  el.style.right = `calc(${(1 - progress) * from + to}%)`;
  el.style.position = 'relative';
};

const slideInFromRight = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType): void => {
  el.style.right = `${(1 - progress) * from + to}px`;
};

const slideInFromLeft = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType): void => {
  el.style.left = `${(1 - progress) * from + to}px`;
};

const slideOutToRight = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.right = `${progress * to + from}px`;
};

const slideOutToLeft = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.left = `${progress * to + from}px`;
};

const slideInFromRightFixed = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType) => {
  el.style.right = `calc(${(1 - progress) * from + to}%)`;
  el.style.position = 'fixed';
};

const slideOutToRightFixed = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.right = `calc(${progress * to + from}%)`;
  el.style.position = 'fixed';
};

const slideInFromLeftFixed = (el: HTMLElement, progress: number, { from = -100, to = 0 }: EffectType) => {
  el.style.left = `calc(${(1 - progress) * from + to}%)`;
  el.style.position = 'fixed';
};

const slideOutToLeftFixed = (el: HTMLElement, progress: number, { from = 0, to = -100 }: EffectType): void => {
  el.style.left = `calc(${progress * to + from}%)`;
  el.style.position = 'fixed';
};

const fadeOut = (el: HTMLElement, progress: number, { from = 1, to = 0 }: EffectType): void => {
  el.style.opacity = `${(1 - progress) * from + progress * to}`;
};

const fadeIn = (el: HTMLElement, progress: number, { from = 0, to = 1 }: EffectType): void => {
  el.style.opacity = `${progress * to + (progress - 1) * from}`;
};

const fadeOutBackdrop = (el: HTMLElement, progress: number, { from = 1, to = 0 }: EffectType): void => {
  el.style.backgroundColor = `rgba(0, 0, 0, ${(1 - progress) * from + progress * to})`;
  el.style.opacity = `${1 - progress + progress * to}`;
};

const fadeInBackdrop = (el: HTMLElement, progress: number, { from = 0, to = 1 }: EffectType): void => {
  el.style.backgroundColor = `rgba(0, 0, 0, ${progress * to + (progress - 1) * from})`;
  el.style.opacity = `${progress + (progress - 1) * from}`;
};

const AnimationsAction = {
  slideOutToLeftRelative,
  slideInFromRightRelative,
  slideInFromLeftRelative,
  slideOutToRightRelative,
  shrinkElement,
  growElement,
  slideInFromRight,
  slideInFromLeft,
  slideOutToRight,
  slideOutToLeft,
  fadeOut,
  fadeIn,
  fadeInBackdrop,
  fadeOutBackdrop,
  slideInFromRightFixed,
  slideOutToRightFixed,
  slideInFromLeftFixed,
  slideOutToLeftFixed
} as const;

export default AnimationsAction;
